/* Buckle Scrunchies PDP enhancements: feature dots, how-to tabs, spec rows, breakdown card roles. */
(function () {
  function q(sel, root) { return (root || document).querySelector(sel); }
  function qa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function section(keys) {
    for (var i = 0; i < keys.length; i++) {
      var s = q('[id$="__' + keys[i] + '"]');
      if (s) return s;
    }
    return null;
  }

  // Features: progress dots for the phone carousel.
  function features() {
    var s = section(['multicolumn_wXgQCg', 'multicolumn_6x6eTA']);
    if (!s || q('.bs-dots', s)) return;
    var list = q('.multicolumn-list', s);
    var items = qa('.multicolumn-list__item', s);
    if (!list || items.length < 2) return;
    var dots = document.createElement('div');
    dots.className = 'bs-dots';
    dots.setAttribute('aria-hidden', 'true');
    items.forEach(function (_, i) {
      var d = document.createElement('span');
      if (i === 0) d.className = 'is-on';
      dots.appendChild(d);
    });
    list.parentNode.insertBefore(dots, list.nextSibling);
    list.addEventListener('scroll', function () {
      var w = items[0].getBoundingClientRect().width + 14;
      var idx = Math.min(items.length - 1, Math.round(list.scrollLeft / w));
      qa('span', dots).forEach(function (d, i) { d.className = i === idx ? 'is-on' : ''; });
    }, { passive: true });
  }

  // How to use: two tabs on phones built from the existing step headings.
  function howto() {
    var s = section(['multicolumn_azGjHU', 'multicolumn_Ew3Jmh']);
    if (!s || q('.bs-tabs', s)) return;
    var items = qa('.multicolumn-list__item', s);
    if (items.length !== 2) return;
    var slider = q('slider-component', s) || q('.multicolumn-list', s);
    var start = 0;
    items.forEach(function (it, i) { var h = q('h3', it); if (h && /down/i.test(h.textContent)) start = i; });
    var tabs = document.createElement('div');
    tabs.className = 'bs-tabs';
    tabs.setAttribute('role', 'tablist');
    items.forEach(function (it, i) {
      var h = q('h3', it);
      var label = h ? h.textContent.replace(/^\s*\d+\.\s*/, '').trim() : 'Step ' + (i + 1);
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('role', 'tab');
      b.setAttribute('aria-selected', i === start ? 'true' : 'false');
      b.textContent = label.charAt(0).toUpperCase() + label.slice(1);
      b.addEventListener('click', function () {
        qa('button', tabs).forEach(function (x, j) { x.setAttribute('aria-selected', j === i ? 'true' : 'false'); });
        items.forEach(function (x, j) { x.classList.toggle('bs-hide', j !== i); });
      });
      tabs.appendChild(b);
    });
    items.forEach(function (x, j) { x.classList.toggle('bs-hide', j !== start); });
    slider.parentNode.insertBefore(tabs, slider);
    s.classList.add('bs-howto-tabbed');
  }

  // Specifications: drop the leading colon so label and value sit in two clean columns.
  function specs() {
    var s = section(['image_with_text_rRkpdt', 'image_with_text_LqdFPQ']);
    if (!s || s.dataset.bs) return;
    s.dataset.bs = '1';
    qa('.image-with-text__text p', s).forEach(function (p) {
      var st = q('strong', p);
      if (!st || p.firstElementChild !== st) return;
      var rest = document.createElement('span');
      while (st.nextSibling) rest.appendChild(st.nextSibling);
      if (rest.firstChild && rest.firstChild.nodeType === 3) rest.firstChild.nodeValue = rest.firstChild.nodeValue.replace(/^\s*:\s*/, '');
      st.textContent = st.textContent.replace(/\s*:\s*$/, '');
      p.appendChild(rest);
    });
  }

  // Breakdown: tag cards by their heading so layout follows content, not position.
  function breakdown() {
    var s = section(['multicolumn_yUmqGH', 'multicolumn_pPnd4G']);
    if (!s || s.dataset.bs) return;
    s.dataset.bs = '1';
    qa('.multicolumn-list__item', s).forEach(function (it) {
      var h = (q('h3', it) || {}).textContent || '';
      h = h.toLowerCase();
      if (/value proposition/.test(h)) it.classList.add('bs-uvp', 'bs-wide');
      if (/benefit|target|audience|key feature|use case/.test(h)) it.classList.add('bs-wide');
      if (/not to use/.test(h)) it.classList.add('bs-not', 'bs-wide');
    });
  }

  // Breadcrumbs: sit at the bottom of the product info, just above Share.
  function crumbs() {
    var nav = q('nav.breadcrumbs--product');
    var info = q('.product__info-container');
    if (!nav || !info) return;
    var share = q('share-button', info);
    var anchor = share;
    while (anchor && anchor.parentElement !== info) anchor = anchor.parentElement;
    if (anchor) info.insertBefore(nav, anchor); else info.appendChild(nav);
    nav.classList.add('bs-crumbs');
  }

  // Review blurb + Who it's for: rendered hidden in the buy box, shown only once moved to the row above Features.
  function band() {
    var info = q('.product__info-container');
    var reviews = info ? q('.pdp-reviews', info) : null;
    var who = q('#bs-who:not(.bs-moved)');
    if (!reviews && !who) return;
    var anchor = section(['multicolumn_wXgQCg', 'multicolumn_6x6eTA']);
    if (!anchor && info) { var ms = info.closest('.shopify-section'); anchor = ms && ms.nextElementSibling; }
    if (!anchor) { [reviews, who].forEach(function (el) { if (el) el.style.display = ''; }); return; }
    var b = q('.bs-band');
    if (b) b.innerHTML = '';
    else { b = document.createElement('div'); b.className = 'page-width bs-band'; }
    if (b.nextElementSibling !== anchor) anchor.parentNode.insertBefore(b, anchor);
    [reviews, who].forEach(function (el) {
      if (!el) return;
      b.appendChild(el);
      el.classList.add('bs-moved');
      el.style.display = '';
    });
  }

  // Judge.me reviews grid: replace "Show more" with a link to the All Reviews page.
  function reviewsLink() {
    qa('.jdgm-reviews-grid-widget .jm-show-more-button').forEach(function (btn) {
      var wrap = btn.parentElement;
      btn.style.display = 'none';
      if (!wrap || q('.bs-allrev', wrap)) return;
      var a = document.createElement('a');
      a.className = 'bs-allrev';
      a.href = '/pages/reviews';
      a.textContent = 'All Reviews';
      wrap.appendChild(a);
    });
  }
  function watchReviews() {
    if (!q('.jdgm-reviews-grid-widget, .jdgm-widget')) return;
    reviewsLink();
    var t, mo = new MutationObserver(function () { clearTimeout(t); t = setTimeout(reviewsLink, 100); });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 30000);
  }

  function run() { crumbs(); band(); features(); howto(); specs(); breakdown(); }
  if (window.__bsPdp) return;
  window.__bsPdp = true;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  if (document.readyState === 'complete') watchReviews(); else window.addEventListener('load', watchReviews);
  document.addEventListener('shopify:section:load', run);
})();
